import { render } from "./MatieresList.vue?vue&type=template&id=3c6ed6ce"
import script from "./MatieresList.vue?vue&type=script&lang=js"
export * from "./MatieresList.vue?vue&type=script&lang=js"

import "./MatieresList.vue?vue&type=style&index=0&id=3c6ed6ce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__